module.exports = __webpack_public_path__ + "static/assets/473648c5f4cd989085a080bb912031b3.svg";